<template>
  <div id="app">
    <router-view v-on:footer="footer"/>
    <app-footer v-if="footer_show"></app-footer>
  </div>
</template>

<script>

import Footer from '@/components/footer'


export default {
  components: {
    'app-footer':Footer,
  },
  name: 'App',

  data () {
    return{
      footer_show:true
    }
  },

  methods: {
    //是否显示底部
    footer:function (bool) {
        this.footer_show = bool;
    },

    //获取code
    getUrlParam (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      let url = window.location.href.split('#')[0]
      let search = url.split('?')[1]
      if (search) {
          var r = search.substr(0).match(reg)
          if (r !== null) return unescape(r[2])
          return null
      } else {
          return null
      }
    }
  },

  created () {
  }
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  color: rgb(80, 80, 80);
  overflow: auto;
  background-color: #fafafa;
}

html, body {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch;
  font-family: Arial;
  font-size: .32rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue